import { atom } from 'recoil';
import { LoginMessageResponse } from '@/types/api/mypage/loginMessage';
import persistAtom from './recoilPersist';

/**
 * ログイン後に表示するバナー・ポップアップメッセージを保持する state。
 * トップ画面とレイアウト部品で共通利用するため、取得済みメッセージ群をまとめて保持する。
 */
// eslint-disable-next-line import/prefer-default-export
export const LoginMessageState = atom<LoginMessageResponse>({
  key: 'LoginMessageState',
  default: {
    banners: [],
    popups: [],
  },
  effects_UNSTABLE: [persistAtom],
});
